import { Input } from 'antd'
import FormItem from 'antd/es/form/FormItem'

export default function StarForm() {
  return (
    <>
      <FormItem label="取餐编号" name="orderNumber">
        <Input placeholder="如：98777" />
      </FormItem>
      <FormItem label="取餐口令" name="orderCode">
        <Input placeholder="如：4. 万事顺遂" />
      </FormItem>
      <FormItem label="下单昵称" name="orderName">
        <Input placeholder="如：咖啡免费的啾啾" />
      </FormItem>
      <FormItem label="订单属性" name="orderType">
        <Input placeholder="如：大/热" />
      </FormItem>
      <FormItem label="订单商品" name="orderContent">
        <Input placeholder="如：抹茶绵云拿铁" />
      </FormItem>
      <FormItem label="商品英文名" name="orderEnglish">
        <Input placeholder="如：G/Hot/MatchaFoammLatte" />
      </FormItem>
      <FormItem label="客制化" name="orderCus">
        <Input placeholder="如：换燕麦奶" />
      </FormItem>
      <FormItem label="下单时间" name="orderTime">
        <Input placeholder="如：2024/08/28 12:11" />
      </FormItem>
    </>
  )
}
